<template>
    <div id="app">
        <div v-if="$route.path === '/mobile-menu'">
            <router-view/>
        </div>
        <span v-else>
        <Header/>
            <div v-if="!agecheck" class="age-check">
                <div class="check-card">
                    <h3>MUST BE 21 OR OLDER TO CONTINUE</h3><br/>
                    <p>The products on this website are intended for adults only. By confirming, you certify that you are of legal smoking age in the state in which you reside.</p>
					<div class="buttons">
						<div @click="agecheck = true">I am 21+</div>
						<div @click="window.location.href = 'http://www.disney.com'">I am under 21</div>
					</div>
                </div>
            </div>
            <div v-if="!scrollTop" style="height: 175px; width: 100%"></div>
            <div id="content">
                <router-view/>
            </div>
        <Footer/>
        </span>
    </div>
</template>
<script>
import Footer from './components/Footer.vue'
import Header from './components/Header.vue'
export default {
    data() {
        return {
            scrollTop: true,
            agecheck: false,
            window: window
        }
    },
    components: {
        Header: Header,
        Footer: Footer
    },
    methods: {
        scrollHandler() {
            if (window.scrollY < 110) this.scrollTop = true
            else this.scrollTop = false
        }
    },
    mounted() {
        window.addEventListener('scroll', this.scrollHandler)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.scrollHandler)
    }
}
</script>

<style lang="scss">

.age-check {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000000aa;
    z-index: 3;
    display: flex;
    justify-content: center;
    align-items: center;
	font-family: Nunito Sans;
    .check-card {
		max-width: 30%;
        h3 {
            font-family: Teko;
            font-size: 2em
        }
		p {
			margin-bottom: 20px;
			font-weight: bold;
		}
        padding: 20px;
        text-align: center;
        display: flex;
        flex-direction: column;
        background-image: linear-gradient(to left, #e5e5e5, #cdace4 64%);
        box-shadow: 5px 5px 5px 0px black;
		.buttons {
			div {
				font-family: Teko;
				font-size: 1.5em;
				width: 100%;
				padding: 5px;
				border: 3px solid white;
				margin-left: 15px;
				margin-right: 15px;
				background: #97d3ce;
				&:hover {
					cursor: pointer;
				}
			}
			display: flex;
			justify-content: center;
			width: 100%;
		}
    }
}

@media screen and (max-width: 1100px) {
	.check-card {
		max-width: 50% !important;
	}
}

@media screen and (max-width: 500px) {
	.check-card {
		max-width: 80% !important;
	}
}

html {
  box-sizing: border-box;
}

*,
*:before,
*:after {
  box-sizing: inherit;
  padding: 0;
  margin: 0;
  list-style: none;
  text-decoration: none;
}

body {
  background: white;
}

</style>
